export const vsName = 'defaultValuesService'

export class DefaultValuesService {
  private readonly defaultValuesMap: { [name: string]: DefaultValueEntry; } = {}

  constructor(defaultValueFactories: { [name: string]: () => angular.IPromise<any> }) {
    this.defaultValuesMap = Object.entries(defaultValueFactories).reduce((result: { [name: string]: DefaultValueEntry }, next) => {
      const [name, factory] = next
      result[name] = new DefaultValueEntry(factory)

      return result
    }, {})
  }

  get(name: string): angular.IPromise<any> {
    return this.defaultValuesMap[name]?.getValue()
  }
}

class DefaultValueEntry {
  factory: () => any
  result: angular.IPromise<any> | null = null

  constructor(factory: () => any) {
    this.factory = factory
  }

  getValue() {
    return this.result ?? (this.result = this.factory())
  }
}